import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Progress } from 'reactstrap';
import { TrendingUp, TrendingDown, Users, Gift, CheckCircle, XCircle, Target } from 'react-feather';
import { formatNumber } from '../../../../../utils/Utils';
import { Icon } from '../../../../../components/Component';

const PromotionDashboardDataOverview = ({ data }) => {
 const [pageData, setPageData] = useState(data);

 useEffect(() => {
  setPageData(data);
 }, [data]);

 return (
  <Card className="h-100 shadow-sm">
   {/* Main Stats Card */}
   <div className="p-4">
    <div className="d-flex justify-content-between align-items-center mb-4">
     <h5 className="fw-bold mb-0">Promotion Overview</h5>
    </div>

    {/* Total Promotions & Participants */}
    <Row className="g-4 mb-4">
     <Col md={6}>
      <div className="bg-light bg-opacity-50 rounded-3 p-3">
       <div className="d-flex align-items-center mb-2">
        <Gift size={20} className="text-primary me-2" />
        <span className="text-muted small">Total Promotions</span>
       </div>
       <div className="h2 fw-bold mb-0">{pageData?.total_promotions || "0"}</div>
      </div>
     </Col>
     <Col md={6}>
      <div className="bg-light bg-opacity-50 rounded-3 p-3">
       <div className="d-flex align-items-center mb-2">
        <Users size={20} className="text-success me-2" />
        <span className="text-muted small">Total Participants</span>
       </div>
       <div className="h2 fw-bold mb-0">{pageData?.total_participants || "0"}</div>
      </div>
     </Col>
    </Row>

    {/* Entry Statistics */}
    <div className="mb-4">
     <div className="d-flex justify-content-between align-items-center mb-3">
      <h6 className="fw-semibold mb-0">Entry Statistics</h6>
      <h7 className="fw-semibold mb-0">Total Entries: {pageData?.total_entries || "0"}</h7>
     </div>

     <Row className="g-3">
      <Col md={6}>
       <div className="d-flex align-items-center">
        <div className="bg-success bg-opacity-10 rounded-2 p-2 me-3">
         <CheckCircle size={16} className="text-success" />
        </div>
        <div>
         <div className="small text-muted">Valid Entries</div>
         <div className="fw-bold">{pageData?.total_valid_entries || "0"}</div>
        </div>
       </div>
      </Col>
      <Col md={6}>
       <div className="d-flex align-items-center">
        <div className="bg-danger bg-opacity-10 rounded-2 p-2 me-3">
         <XCircle size={16} className="text-danger" />
        </div>
        <div>
         <div className="small text-muted">Invalid Entries</div>
         <div className="fw-bold">{pageData?.total_invalid_entries || "0"}</div>
        </div>
       </div>
      </Col>
     </Row>

     {/* Success Rate Progress Bar */}
     <div className="my-4">
      <div className="d-flex justify-content-between align-items-center mb-1">
       <span className="small text-muted">Success Rate</span>
       <span className="small fw-bold">{formatNumber(pageData?.entries_percentage_success_rate || 0) || "0"}%</span>
      </div>
      <Progress
       value={pageData?.entries_percentage_success_rate || "0"}
       color="success"
       style={{ height: '8px' }}
       className="rounded-pill"
      />
     </div>

     <div className="d-flex justify-content-between align-items-center mb-3">
      <h6 className="fw-semibold mb-0">Gender Distribution</h6>
     </div>


     <Row className="g-3">
      <Col md={6}>
       <div className="d-flex align-items-center">
        <div className="bg-success bg-opacity-10 rounded-2 p-2 me-3">
         <Icon name="user" className="bg-primary-dim"></Icon>
        </div>
        <div>
         <div className="small text-muted">Total Males</div>
         <div className="fw-bold">{pageData?.male_participants_count || 0}</div>
        </div>
       </div>
      </Col>
      <Col md={6}>
       <div className="d-flex align-items-center">
        <div className="bg-danger bg-opacity-10 rounded-2 p-2 me-3">
         <Icon name="user-list" className="bg-pink-dim"></Icon>
        </div>
        <div>
         <div className="small text-muted">Total Females</div>
         <div className="fw-bold">{pageData?.female_participants_count || 0}</div>
        </div>
       </div>
      </Col>
     </Row>
    </div>
   </div>
  </Card>
 );
};

export default PromotionDashboardDataOverview;